import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/tags/searchbar";
import TagsTable from "../../../containers/admin/tags/table";
import AddTag from "../../../containers/admin/tags/models/add-tag";
import { getAllTagsRequest } from "../../../modules/admin-modules/tags/Actions";

const Tags = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllTagsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <TagsTable setAdd={setAdd} setSelectedData={setSelectedData} searchTerm={searchTerm} />
      <AddTag
        key={`tag-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Tags;
